module.exports = __webpack_public_path__ + "static/img/moce_05.f5efbc3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/moce_05.png
// module id = IYRG
// module chunks = 22